import SettingsModal from "components/modals/SettingsModal.js"
import React, {useState} from 'react';
import accounts from 'accounts/Accounts.js';
import {connect} from 'react-redux';
import ExploreSearch from  './ExploreSearch.js';
import LoginModal from 'components/modals/LoginModal.js';
import TransactionsView from 'components/toolbar/TransactionsView.js';
import GuildsMenu from 'components/guilds/GuildsMenu.js';
import {setExploreOption} from 'actions/index.js';
import {HOME, GUILDS, MESSAGES} from 'constants/explore-options.js';

const Navigation = ({
    setSearchTerm,
    searchTerm,
    store,
    showLogin,
    option,
    setOption,
    searchOptions,
    setSearchOptions,
}) => {
    let [showPreferences, setShowPreferences] = useState(false);
    let loggedIn = accounts.isLoggedIn();
    let className = "navigation";
    if (!loggedIn) {
        className += " logged-off";
    }

    return (
        <div className={className}>
          <Option name="Home" option={HOME} selected={option === HOME} onClick={setOption}/>
          <Option name="Guilds" option={GUILDS} selected={option === GUILDS} onClick={setOption}/>
          <Option name="Messages" option={MESSAGES} selected={option === MESSAGES} onClick={setOption}/>
          <div
            onClick={() => setShowPreferences(true)}
            className="preferences-btn">Preferences</div>
          <GuildsMenu store={store}/>
          <TransactionsView/>
          <LoginModal show={showLogin}/>
          {showPreferences ? <SettingsModal hide={() => setShowPreferences(false)} onlyAppearance={true}/> : ''}
        </div>
    );
}

const Option = ({name, option, selected, onClick}) => {
    let className = "option";
    if (selected) {
        className += " selected";
    }
    return (
        <div onClick={() => onClick(option)} className={className}>
          {name}
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOption: (o) => dispatch(setExploreOption(o))
    };
};
const mapStateToProps = state => {
    return {
        selectedRecord: state.discover.selectedRecord,
        selectedGuild: state.guilds.selectedGuild,
        showLogin: state.sequencer.showLogin,
        option: state.explore.exploreOption,
        userToken: state.sequencer.userToken
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);

